import type { MessageTemplateKey } from '@/types'

/*
 * WhatsApp messaging is kept behind a small channel interface. Today the
 * only channel opens WhatsApp's click-to-chat link with the message ready,
 * and the operator presses send. A WhatsApp Business Cloud API channel can
 * implement the same interface later and send the message directly.
 */

export type MessageVariables = {
    vehicle: string
    model: string
    service: string
    amount: string
    invoice: string
    customer: string
    business: string
}

export type MessagingResult = {
    status: 'opened' | 'sent'
}

export type MessagingChannel = {
    id: 'whatsapp-link'
    label: string
    send: (input: { phone: string, text: string }) => Promise<MessagingResult>
}

export const fillTemplate = (template: string, variables: Partial<MessageVariables>): string => template
    .replace(/\{(\w+)\}/g, (match, key: string) => {
        const value = variables[key as keyof MessageVariables]
        return value === undefined ? match : value
    })
    .replace(/\n{3,}/g, '\n\n')
    .trim()

export const buildWhatsAppUrl = (phone: string, text: string): string => `https://wa.me/${phone}?text=${encodeURIComponent(text)}`

export const whatsappLinkChannel: MessagingChannel = {
    id: 'whatsapp-link',
    label: 'WhatsApp',
    send: async ({ phone, text }) => {
        const link = document.createElement('a')

        link.href = buildWhatsAppUrl(phone, text)
        link.target = '_blank'
        link.rel = 'noopener noreferrer'

        document.body.appendChild(link)
        link.click()
        link.remove()

        return { status: 'opened' }
    }
}

export const suggestTemplate = (stage: 'active' | 'completed' | 'paid'): MessageTemplateKey => {
    if (stage === 'paid') return 'payment'
    if (stage === 'completed') return 'completed'
    return 'received'
}
